/**
 * SizilPro — useNotifications
 * Thin wrapper around sonner for consistent toast calls across the app.
 */

import { toast } from "sonner";

export function useNotifications() {
  return {
    success: (title: string, description?: string) =>
      toast.success(title, { description }),

    error: (title: string, description?: string) =>
      toast.error(title, { description }),

    info: (title: string, description?: string) =>
      toast.info(title, { description }),

    warning: (title: string, description?: string) =>
      toast.warning(title, { description }),

    loading: (title: string, description?: string) =>
      toast.loading(title, { description }),

    dismiss: (id?: string | number) =>
      toast.dismiss(id),

    promise: <T>(
      promise: Promise<T>,
      opts: { loading: string; success: string; error: string }
    ) => toast.promise(promise, opts),
  };
}
